import { RegistereRibbonButton, useAppInfo, useModelDrivenApp, useRibbon, useSelectionContext } from "@eavfw/apps";
import { useEAVForm } from "@eavfw/forms";
import { useClientContext, useJsonFetcher } from "@eavfw/manifest";


RegistereRibbonButton("CUSTOM_RIBBON_SEND_LOI_LINK", ({ key, ...props }) => {
    const { registerButton, events } = useRibbon();
    const { currentEntityName, currentRecordId } = useAppInfo();
    const { baseUrl } = useClientContext();
    const [loidocumentpdfid] = useEAVForm(x => x.formValues.loidocumentpdfid);
    const app = useModelDrivenApp();
    const [_baseUrl, fetcher] = useJsonFetcher();

    const a = useSelectionContext();

    registerButton({
        key: key,
        disabled: a.selection.count ===0,
        text: props.text,
        iconProps: props.iconProps ?? { iconName: 'Send' },
        title: props.title ?? props.text,
        onClick: () => {
            console.log(a.selection.getSelection());

            let rsp = fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/entities/${app.getEntity(currentEntityName).collectionSchemaName}/records/${currentRecordId}/workflows/${props.workflow}/runs`, {
                method: "POST",
                body: JSON.stringify({
                    recipients: a.selection.getSelection().map(x => x.id),
                }),
                credentials: "include"
            });
        }
        //workflow: props.workflow
        // onClick: onClick
    }, [a.selection.count]);

});

